(function () {
  const SELECTOR = '.product-card__atc:not(.pdc-atc)';

  function readCookie(name) {
    const prefix = name + '=';
    const entry = document.cookie.split('; ').find((c) => c.startsWith(prefix));
    if (!entry) return null;
    try {
      return JSON.parse(decodeURIComponent(entry.slice(prefix.length)));
    } catch {
      return null;
    }
  }

  function hasLocation() {
    const loc = readCookie('locationDrawerSelected');
    if (loc && (loc.name || (loc.latitude && loc.longitude))) return true;
    const addr = readCookie('addressDrawerResult');
    if (addr && addr.latitude && addr.longitude) return true;
    return false;
  }

  function initButton(btn) {
    if (!('outOfStock' in btn.dataset) && btn.disabled) {
      btn.dataset.outOfStock = 'true';
    }
    applyGate(btn);
  }

  function applyGate(btn) {
    if (btn.dataset.outOfStock === 'true') return;
    if (hasLocation()) {
      btn.removeAttribute('disabled');
    } else {
      btn.setAttribute('disabled', 'disabled');
    }
  }

  function updateAll() {
    document.querySelectorAll(SELECTOR).forEach(applyGate);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SELECTOR).forEach(initButton);

    new MutationObserver((mutations) => {
      for (const { addedNodes } of mutations) {
        for (const node of addedNodes) {
          if (!(node instanceof Element)) continue;
          node.querySelectorAll(SELECTOR).forEach(initButton);
          if (node.matches(SELECTOR)) initButton(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('location:changed', updateAll);
  document.addEventListener('deliveryAddress:updated', updateAll);
})();
